/** @format */

export const config = {
  
   strapiAPi:  process.env.NEXT_PUBLIC_STRAPI_API

   //strapiAPi: "https://api.iknotanalytics.com", //'https://api.visionfacts.ai'// http://143.244.137.145:5000/ http://localhost:1337
  //strapiAPi: "http://localhost:1337"
   };
